import { Button, Card, Icon, InlineStack, LegacyCard, Tabs, TextField } from '@shopify/polaris';
import { useState, useCallback } from 'react';
import { DeleteIcon, ViewIcon } from '@shopify/polaris-icons';

export default function Settings() {
    const [selected, setSelected] = useState(0);

    const handleTabChange = useCallback(
        (selectedTabIndex) => setSelected(selectedTabIndex),
        []
    );

    const tabs = [
        {
            id: 'ShirtNumber',
            content: 'Shirt Number',
            accessibilityLabel: 'All customers',
            panelID: 'all-customers-content-1',
        },
        {
            id: 'SatinNumbers',
            content: 'Satin Numbers',
            panelID: 'accepts-marketing-content-1',
        },
        {
            id: 'repeat-customers-1',
            content: 'Repeat customers',
            panelID: 'repeat-customers-content-1',
        },
        {
            id: 'prospects-1',
            content: 'Prospects',
            panelID: 'prospects-content-1',
        },
    ];

    return (
        <><div className="button_option">
            <h2>Settings</h2>
        </div>
            <LegacyCard>
                <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
                    {/* <LegacyCard.Section title={tabs[selected].content}>
                        <p>Tab {selected} selected</p>
                    </LegacyCard.Section> */}
                    <div className='settings_main_option'>
                        <div className='addButton'>
                            <Button variant="primary">Add Entry</Button>
                        </div>
                        <div className='search_option'>
                            <TextField
                                placeholder='Search Number...'
                                value=""
                                autoComplete="off"
                            />
                        </div>

                        <ul>
                            <li>
                                <span>Shirt Number</span>
                                <div className='icons'>
                                    <Icon source={DeleteIcon} tone="base" />
                                    <Icon source={ViewIcon} tone="base" />
                                </div>

                            </li>
                            <li>
                                <span>Shirt Number</span>
                                <div className='icons'>
                                    <Icon source={DeleteIcon} tone="base" />
                                    <Icon source={ViewIcon} tone="base" />
                                </div>

                            </li>
                        </ul>
                    </div>
                </Tabs>
            </LegacyCard>

            <div className='settings_data_popup'>
                <div className='setting_form'>
                    <TextField
                        placeholder="Store name"
                        value=""
                        autoComplete="off"
                    />
                    <Icon source={DeleteIcon} tone="base" />
                </div>
            </div>
        </>
    );
}
